"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(overloads) {
  return function () {
    var fn = overloads["".concat(arguments.length)];

    if (!fn) {
      throw new Error("Function must be given this many arguments: ".concat(Object.keys(overloads).join(", ")));
    }

    return fn.apply(void 0, arguments);
  };
};

exports.default = _default;